<template>
  <div
    class="table-responsive pt-2 pl-4 pr-4"
    v-if="options.length > 0"
  >
    <div class="col-12 pt-3 pb-3 pl-4">
      <h3>Historico</h3>
    </div>
    <Tables
      ref="tableGrid"
      :columns="['Valor', 'Responsavel', 'Data']"
      :showTipFooter="false"
      :showPaging="false"
    >
      <tr
        v-for="obj in this.objList"
        v-bind:key="obj.id"
      >
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="formatValue(obj.valor)"
        />
        <TableColumn
          :IsText="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.createdBy ? obj.createdBy.nomePessoa : ''"
        />
        <TableColumn
          :IsDatetime="true"
          :status="obj.inative ? 0 : 1"
          :value="obj.createdAt"
        />
      </tr>
    </Tables>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'HistoryTable',
  mixins: [ActionsForm],
  props: {
    options: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  watch: {
    options () {
      if (this.options.length > 0) {
        this.loadAll()
      }
    }
  },
  methods: {
    onLoad () {},
    formatValue (value) {
      let result
      if (value !== null || value !== undefined) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    loadAll () {
      this.$nextTick(() => {
        this.onResultGridWithNoResponse(this.options)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visitas/kmValue/components/add/historyTable/HistoryTable.vue